import config from "./config.js";
import ComponentLoad from "./component.load.js";
import ComponentProfile from "./component.profile.js";
import ComponentAgent from "./component.agent.js";
import ComponentPremiumBanner from "./component.premiumBanner.js";
import ComponentCommerceBanner from "./component.commerceBanner.js";
import ComponentAddresses from "./component.addresses.js";
import ComponentPayment from "./component.payment.js";
import Trace from "./libs/snake.lib.trace.js";
import Identity from "./libs/snake.lib.identity.js";

export default class Component {
    static modalI18nGenericOptions = {
        text: window.snakeCheckout.translations["error.generic"],
        dismissBtn: window.snakeCheckout.translations["modal.close"],
    };

    static load = (componentReference) => {
        const componentMethod = this.components[componentReference];

        if (componentMethod) componentMethod();
    };

    static components = {
        _cmpLoad: () => ComponentLoad.init(),
        _cmpAgent: () => ComponentAgent.init(),
        _cmpProfile: () => ComponentProfile.init(),
        _cmpPremiumBanner: () => ComponentPremiumBanner.init(),
        _cmpCommerceBanner: () => ComponentCommerceBanner.init(),
        _cmpAddresses: () => ComponentAddresses.init(),
        _cmpPayment: () => ComponentPayment.init(),
    };

    static getModalI18nGenericOptions() {
        return this.modalI18nGenericOptions;
    }

    static scrollTo(component) {
        window.scrollTo({
            top: document.getElementById(component).offsetTop - document.querySelector("header").offsetHeight - 15,
            left: 0,
            behavior: "smooth",
        });
    }

    static setCheckoutStepsVisibility = (steps = [], show) => {
        Trace.debug("setCheckoutStepsVisibility " + steps.join(" - ") + " | " + show);

        if (steps.includes(config.routing.sections.agent.component)) {
            const componentAgentDom = document.getElementById(config.routing.sections.agent.component);
            const componentAgentTabDom = document.querySelector("[data-tabs='sign-in-agent']");
            const componentProfileDom = document.getElementById(config.routing.sections.profile.component);

            if (componentAgentDom && componentProfileDom) {
                if (show) {
                    document.querySelector("body header #logo").dataset.agent = "Agent";

                    if (componentAgentTabDom) componentAgentTabDom.classList.remove("hidden");

                    componentProfileDom.querySelector("#button_agentGenerateEmail").classList.remove("hidden");
                    componentProfileDom.querySelector("#agent-order-type").parentElement.classList.remove("hidden");
                    if (componentProfileDom.querySelector("div.sign-in")) componentProfileDom.querySelector("div.sign-in").remove();
                    if (componentProfileDom.querySelector("[data-tabs='sign-in']")) componentProfileDom.querySelector("[data-tabs='sign-in']").remove();

                    if (Identity.isAgentCustomer()) {
                        document.querySelector("header #chat").classList = "hidden";

                        document.querySelectorAll("header #phone, footer, #sidebar, .sign-up > div:last-child, .not-auth > ul, #_cmpPayment").forEach((el) => {
                            el.remove();
                        });

                        document.querySelector("main").classList.add("mb-24");
                        document.querySelector("main > div:first-child").classList = "col-span-12 px-4";

                        componentProfileDom.querySelector("#agent-order-type").parentElement.remove();
                    }
                } else {
                    componentAgentDom.parentElement.remove();

                    componentAgentTabDom.remove();

                    componentProfileDom.querySelector("#button_agentGenerateEmail").remove();
                    componentProfileDom.querySelector("#agent-order-type").parentElement.remove();
                }
            }
        }

        if (steps.includes(config.routing.sections.profile.component)) {
            const componentDom = document.getElementById(config.routing.sections.profile.component);

            if (componentDom) {
                if (show) componentDom.classList.remove("hidden");
                else componentDom.classList.add("hidden");
            }
        }

        if (steps.includes(config.routing.sections.addresses.component)) {
            const componentDom = document.getElementById(config.routing.sections.addresses.component);

            if (componentDom) {
                if (window.snakeCheckout.accountInfo.data.shippingAddresses?.length !== 0) {
                    if (show) componentDom.querySelector(".next-times").classList.remove("hidden");
                    else componentDom.querySelector(".next-times").classList.add("hidden");
                } else {
                    if (show) componentDom.querySelector(".first-time > form").classList.remove("hidden");
                    else componentDom.querySelector(".first-time > form").classList.add("hidden");
                }
            }
        }

        if (steps.includes(config.routing.sections.payment.component)) {
            const componentDom = document.getElementById(config.routing.sections.payment.component);

            if (componentDom) {
                if (show) componentDom.querySelector(":scope > div:last-child").classList.remove("hidden");
                else componentDom.querySelector(":scope > div:last-child").classList.add("hidden");
            }
        }
    };
}
